// Préférences d'affichage du suivi en direct : niveau de zoom et défilement
// automatique.
//
// Ces réglages sont volontairement propres à cette page. Les clés sont
// préfixées `lz.liveScores.`, et le zoom est appliqué en CSS sur le conteneur
// de la page plutôt que par le zoom navigateur : régler l'affichage projeté
// d'une salle ne doit pas déformer le reste de Landing Zone.

const ZOOM_KEY = "lz.liveScores.zoom";
const AUTO_SCROLL_KEY = "lz.liveScores.autoScroll";

// Même échelle que les crans du zoom navigateur, pour que les boutons − / +
// donnent la sensation attendue.
export const ZOOM_STEPS = [
  0.5, 0.67, 0.75, 0.8, 0.9, 1, 1.1, 1.25, 1.5, 1.75, 2,
];

export const DEFAULT_ZOOM = 1;

// Le localStorage peut être indisponible (navigation privée, quota, iframe
// cloisonnée). L'écran doit fonctionner sans persistance plutôt que tomber.
const safeRead = (key) => {
  try {
    return window.localStorage.getItem(key);
  } catch (error) {
    return null;
  }
};

const safeWrite = (key, value) => {
  try {
    window.localStorage.setItem(key, value);
  } catch (error) {
    /* rien à faire : la préférence ne sera pas retenue */
  }
};

export const loadZoom = () => {
  const parsed = parseFloat(safeRead(ZOOM_KEY));
  // Une valeur hors échelle (ancienne version, édition manuelle) est ignorée
  // plutôt que de produire un affichage illisible au chargement.
  return ZOOM_STEPS.includes(parsed) ? parsed : DEFAULT_ZOOM;
};

export const saveZoom = (zoom) => safeWrite(ZOOM_KEY, String(zoom));

export const loadAutoScroll = () => safeRead(AUTO_SCROLL_KEY) === "1";

export const saveAutoScroll = (enabled) =>
  safeWrite(AUTO_SCROLL_KEY, enabled ? "1" : "0");

// Cran suivant / précédent, borné aux extrémités de l'échelle.
export const stepZoom = (zoom, direction) => {
  const currentIndex = ZOOM_STEPS.indexOf(zoom);
  const fromIndex =
    currentIndex === -1 ? ZOOM_STEPS.indexOf(DEFAULT_ZOOM) : currentIndex;
  const nextIndex = Math.min(
    ZOOM_STEPS.length - 1,
    Math.max(0, fromIndex + direction)
  );
  return ZOOM_STEPS[nextIndex];
};
